import React from 'react'

function EnrollMessage() {
    return (
        <div>
            <h3 className="mt-5">Please, go back and select any course.</h3>
        </div>
    )
}

export default EnrollMessage
